import React from 'react'
import { customTwMerge } from '~/lib/tv'

export type ContainerProps = {
  children: React.ReactNode
  className?: string
  asElement?: keyof JSX.IntrinsicElements
}

export default function Container({ children, className, asElement }: ContainerProps) {
  const Elem = asElement || 'div'
  return (
    <Elem className={customTwMerge('px-4 lg:px-10 w-full max-w-screen-2xl self-center', className)}>
      {children}
    </Elem>
  )
}
